import { ReactNode, useState } from 'react';
import { TabButtonStrip } from './TabButtonStrip';
import { TabbedComponent } from './TabbedComponent';

require('./TabContainer.css');

export type Props = {
    id?: string;
    className?: string;
    tabLabels: string[];
    children: ReactNode[];
};

export const TabContainer = ({ id, className = '', tabLabels, children }: Props) => {
    const [ activeTabIndex, setActiveTabIndex ] = useState(0);
    return (
        <div
            id={ id }
            className={ `tab-container ${className}` }
        >
            <TabButtonStrip
                tabLabels={ tabLabels }
                activeTabIndex={ activeTabIndex }
                onSelect={ setActiveTabIndex }
            />
            <div className="tab-page-host">
                { children.map((child, i) =>
                    <TabbedComponent
                        key={ i }
                        tabIndex={ i }
                        component={ child }
                        active={ i === activeTabIndex }
                    />
                ) }
            </div>
        </div>
    );
};
